import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProductSignupComponent } from './product-signup.component';
import { ProductsComponent } from './products/products.component';
import { EquityComponent } from './products/equity/equity.component';
import { PdfImagePreviewComponent } from './form-element/document-upload/pdf-image-preview/pdf-image-preview.component';
import { FixedIncomeComponent } from './products/fixed-income/fixed-income.component';
import { MarginTradingComponent } from './products/margin-trading/margin-trading.component';

const routes: Routes = [
  {
    path: ':productId/signup',
    component: ProductSignupComponent,
    // canActivate: [CustomerOptionsPrivilegeGuard, ProductSignUpPrivilegeGuard],
    children: [
      {
        path: 'personal-details',
        component: ProductSignupComponent,
        // canActivate: [CustomerOptionsPrivilegeGuard, ProductSignUpPrivilegeGuard],
      },

      // {
      //   path: 'complete',
      //   component: ProductSignupComponent,
      //   canActivate: [CustomerOptionsPrivilegeGuard, ProductSignUpPrivilegeGuard],
      //   animation: { value: 'signup' },
      // },
    ],
  },
  {
    path: 'products',
    component: ProductsComponent,
    // canActivate: [CustomerOptionsPrivilegeGuard, ProductSignUpPrivilegeGuard],
    children: [
      {
        path: 'equity',
        component: EquityComponent,
        // canActivate: [CustomerOptionsPrivilegeGuard, ProductSignUpPrivilegeGuard],
      },
      {
        path: 'margin-trading',
        component: MarginTradingComponent,
        // canActivate: [CustomerOptionsPrivilegeGuard, ProductSignUpPrivilegeGuard],
      },
      {
        path: 'fixed-income',
        component: FixedIncomeComponent,
        // canActivate: [CustomerOptionsPrivilegeGuard, ProductSignUpPrivilegeGuard],
      },
      {
        path: 'preview/:type/:s3Url',
        component: PdfImagePreviewComponent,
        // canActivate: [CustomerOptionsPrivilegeGuard, ProductSignUpPrivilegeGuard],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProductSignupRoutingModule {}
